import React from "react";

import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

const PendingBookingData = () => {
  const data = [
    {
      name: "Jan",
      uv: 5
    },
    {
      name: "Feb",
      uv: 10
    },
    {
      name: "Mar",
      uv: 15
    },
    {
      name: "Apr",
      uv: 15
    },
    {
      name: "May",
      uv: 5
    },
    {
      name: "June",
      uv: 8
    },
    {
      name: "July",
      uv: 10
    },
    {
      name: "Aug",
      uv: 12
    },
    {
      name: "Sep",
      uv: 18
    },
    {
      name: "Oct",
      uv: 10
    },
    {
      name: "Nov",
      uv: 8
    },
    {
      name: "Dec",
      uv: 5
    }
  ];

  return (
    <>
      <div className="header-flex">
        <div className="heading">
          <h2>Pending Booking</h2>
        </div>
        <div className="selectDate">
          <input
            type="date"
            placeholder="Select Date"
            name="todaysScheduledTraining"
            id="todaysScheduledTraining"
            title="From"
          />
          <input
            type="date"
            placeholder="Select Date"
            name="todaysScheduledTraining"
            id="todaysScheduledTraining"
            title="To"
          />
        </div>
      </div>
      <div className="dataContent">
        <h2>Average Pending Booking</h2>
        <ResponsiveContainer width="100%" height={250}>
          <AreaChart
            data={data}
            margin={{
              top: 10,
              right: 30,
              left: 0,
              bottom: 0,
            }}
          >
            {/* <CartesianGrid strokeDasharray="3 3" /> */}
            <XAxis dataKey="name" />
            <YAxis />
            <Tooltip />
            <Area
              dataKey="uv"
              strokeWidth={3}
              stroke="rgb(var(--SecondaryColorHex))"
              fill="rgba(var(--SecondaryColorHex), 0.06)"
            />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </>
  );
};

export default PendingBookingData;
